/**
 * Cams API
 * Cams
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface LoanApplicationDetailedList { 
    id?: number;
    creationTime?: string;
    memberName?: string | null;
    principleAmount?: number;
    loanApplicationStatus?: string | null;
    loanProductName?: string | null;
    tenure?: number;
    tenurePeriodTypeTitle?: string | null;
    loanOfficerName?: string | null;
    loanOfficerUserId?: number;
    loanApplicationStagesId?: number;
    loanStage?: string | null;
    stageAssignee?: string | null;
    description?: string | null;
}

